import { useEffect, useState } from 'react';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { Provider } from 'services/Analytics/core';
import { getAbTestName } from 'services/Analytics/helpers';
import { getStringSafe } from 'services/Eppo';

import InstallAppStepsA from './InstallAppStepsA';
import InstallAppStepsDefault from './InstallAppStepsDefault';
import { IInstallAppSteps } from './types';

const InstallAppSteps = (props: IInstallAppSteps) => {
    const [variant, setVariant] = useState<string | undefined>();

    useEffect(() => {
        const e = getStringSafe({
            flag: ONGOING_EXPERIMENTS.DownloadPageRedesign,
            def: 'Default',
        });

        setVariant(e);

        Provider.provideData({
            abTestName: async () =>
                getAbTestName({
                    experiment: ONGOING_EXPERIMENTS.DownloadPageRedesign,
                    variantName: e,
                }),
        });

        return () => {
            Provider.provideData({ abTestName: async () => null });
        };
    }, []);

    switch (variant) {
        case 'a':
            return <InstallAppStepsA {...props} />;

        case 'default':
            return <InstallAppStepsDefault {...props} />;

        default:
            return <InstallAppStepsDefault {...props} />;
    }
};

export default InstallAppSteps;
